import TaskApi from '@/api/task'
// @ts-ignore
import OSS from 'ali-oss'
import { uuid } from '@/utils/util'
export function createOssClient() {
	return new Promise(async (resolve, reject) => {
		const res = await TaskApi.getAliyunOssInfo()
		const client = new OSS({
			region: 'oss-cn-shenzhen',
			endpoint: res.data.endpoint,
			accessKeyId: res.data.accessKeyId,
			accessKeySecret: res.data.accessKeySecret,
			bucket: res.data.bucketName,
			stsToken: res.data.securityToken,
			secure: true, // 上传链接返回支持https
		})
		resolve(client)
	})
}

export function ossUploadFile(file: any) {
	return new Promise((resolve, reject) => {
		const date = new Date().getTime() // 当前时间戳
		//这里匹配到的是
		const extensionName = file.name.split('.')[file.name.split('.').length - 1] // 文件扩展名
		const fileName = uuid() + '.' + extensionName // 文件名字（相对于根目录的路径 + 文件名）
		// 执行上传
		createOssClient().then((client: any) => {
			// 异步上传,返回数据
			const url = client.signatureUrl(fileName)
			resolve({
				fileName: file.name,
				fileUrl: fileName,
				url: url,
			})
			// 上传处理
			// 分片上传文件

			client
				.multipartUpload(fileName, file, {
					progress: function(p: any) {
						const e: any = {}
						e.percent = Math.floor(p * 100)
						// option.onProgress(e)
					},
				})
				.then(
					(val: any) => {
						// window.url = val
						if (val.res.statusCode === 200) {
							// option.onSuccess(val)
							// this.$message.success('上传成功')
							// this.video_url = val.res.requestUrls[0].split('?')[0] //这个也很重要,必须切割,要不链接显示错误
							val.url = url
							val.fileName = file.name
							return val
						} else {
							// option.onError('上传失败')
							// this.$message.error('上传失败')
						}
					},
					(err: any) => {
						console.log('上传失败err', err)
						// this.$message.error('上传失败')
						reject(err)
					}
				)
		})
	})
}
